// Category and subcategory data structure
export const categoryData = {
  'decals-clings': {
    id: 'decals-clings',
    name: 'Decals & Clings',
    folder: 'Decals_and_Clings',
    image: '/images/categories/Decals_and_Clings/Decals_and_Clings.png',
    heroImage: '/images/categories/Decals_and_Clings/Decals_and_Clings_HERO.png',
    summaryImage: '/images/categories/Decals_and_Clings/Decals_and_Clings_SUMMARY.png',
    subcategories: [
      {
        id: 'indoor-floor-decals',
        name: 'Indoor Floor Decals',
        folder: 'Indoor_Floor_Decals'
      },
      {
        id: 'street-decals',
        name: 'Street Decals',
        folder: 'Street_Decals'
      },
      {
        id: 'wall-decals',
        name: 'Wall Decals',
        folder: 'Wall_Decals'
      },
      {
        id: 'vinyl-graphics',
        name: 'Vinyl Graphics',
        folder: 'Vinyl_Graphics'
      },
      {
        id: 'clear-decals',
        name: 'Clear Decals',
        folder: 'Clear_Decals'
      },
      {
        id: 'static-clings',
        name: 'Static Clings (white or clear)',
        folder: 'Static_Clings_white_or_clear'
      }
    ]
  },
  'labels': {
    id: 'labels',
    name: 'Labels',
    folder: 'Labels',
    image: '/images/categories/Labels/Labels.png',
    heroImage: '/images/categories/Labels/Labels_HERO.png',
    summaryImage: '/images/categories/Labels/Labels_SUMMARY.png',
    subcategories: [
      {
        id: 'white-vinyl-pages',
        name: 'White Vinyl (Pages)',
        folder: 'White_Vinyl_Pages'
      },
      {
        id: 'clear-bopp-rolls',
        name: 'Clear BOPP (Rolls)',
        folder: 'Clear_BOPP_Rolls'
      },
      {
        id: 'white-bopp-rolls',
        name: 'White BOPP (Rolls)',
        folder: 'White_BOPP_Rolls'
      },
      {
        id: 'gold-silver-foil',
        name: 'Gold & Silver Foil (Rolls)',
        folder: 'Gold_and_Silver_Foil_Rolls'
      },
      {
        id: 'semigloss-paper',
        name: 'SemiGloss Paper (Rolls)',
        folder: 'SemiGloss_Paper_Rolls'
      },
      {
        id: 'writable-bopp',
        name: 'Writable BOPP (Rolls)',
        folder: 'Writable_BOPP_Rolls'
      }
    ]
  },
  'specialty-niche': {
    id: 'specialty-niche',
    name: 'Specialty Niche Products',
    folder: 'Specialty_Niche_Products',
    image: '/images/categories/Specialty_Niche_Products/Specialty_Niche_Products.png',
    heroImage: '/images/categories/Specialty_Niche_Products/Specialty_Niche_Products_HERO.png',
    summaryImage: '/images/categories/Specialty_Niche_Products/Specialty_Niche_Products_SUMMARY.png',
    subcategories: [
      {
        id: 'embossing',
        name: 'Embossing',
        folder: 'Embossing'
      },
      {
        id: 'hot-stamping',
        name: 'Hot Stamping',
        folder: 'Hot_Stamping'
      },
      {
        id: 'silkscreen-effects',
        name: 'Silkscreen Effects',
        folder: 'Silkscreen_Effects'
      },
      {
        id: 'scratch-n-sniff',
        name: "Scratch 'N Sniff",
        folder: 'Scratch_N_Sniff'
      },
      {
        id: 'colour-changing-ink',
        name: 'Colour Changing Ink',
        folder: 'Colour_Changing_Ink'
      },
      {
        id: 'back-print',
        name: 'Back Print',
        folder: 'Back_Print'
      }
    ]
  },
  'stickers': {
    id: 'stickers',
    name: 'Stickers',
    folder: 'Stickers',
    image: '/images/categories/Stickers/Stickers.png',
    heroImage: '/images/categories/Stickers/Stickers_HERO.png',
    summaryImage: '/images/categories/Stickers/Stickers_SUMMARY.png',
    subcategories: [
      {
        id: 'custom-stickers',
        name: 'Custom Stickers',
        folder: 'Custom_Stickers'
      },
      {
        id: 'die-cut-singles',
        name: 'Die-Cut Sticker Singles',
        folder: 'Die-Cut_Sticker_Singles'
      },
      {
        id: 'transparent-stickers',
        name: 'Transparent Stickers',
        folder: 'Transparent_Stickers'
      },
      {
        id: 'holographic-stickers',
        name: 'Holographic Stickers',
        folder: 'Holographic_Stickers'
      },
      {
        id: 'glitter-stickers',
        name: 'Glitter Stickers',
        folder: 'Glitter_Stickers'
      },
      {
        id: 'permanent-stickers',
        name: 'Permanent Stickers',
        folder: 'Permanent_Stickers'
      }
    ]
  },
  'unique-custom': {
    id: 'unique-custom',
    name: 'Unique Custom Products',
    folder: 'Unique_Custom_Products',
    image: '/images/categories/Unique_Custom_Products/Unique_Custom_Products.png',
    heroImage: '/images/categories/Unique_Custom_Products/Unique_Custom_Products_HERO.png',
    summaryImage: '/images/categories/Unique_Custom_Products/Unique_Custom_Products_SUMMARY.png',
    subcategories: [
      {
        id: 'multi-ply-labels',
        name: 'Multi-Ply Labels',
        folder: 'Multi-Ply_Labels'
      },
      {
        id: 'uv-dtf-stickers',
        name: 'UV DTF Stickers',
        folder: 'UV_DTF_Stickers'
      },
      {
        id: 'magnets',
        name: 'Magnets',
        folder: 'Magnets'
      },
      {
        id: 'vehicle-magnets',
        name: 'Vehicle Magnets',
        folder: 'Vehicle_Magnets'
      },
      {
        id: 'glow-in-dark',
        name: 'Glow In The Dark',
        folder: 'Glow_In_The_Dark'
      },
      {
        id: 'packing-tape',
        name: 'Packing Tape',
        folder: 'Packing_Tape'
      }
    ]
  },
  'wearables': {
    id: 'wearables',
    name: 'Wearables',
    folder: 'Wearables',
    image: '/images/categories/Wearables/Wearables.png',
    heroImage: '/images/categories/Wearables/Wearables_HERO.png',
    summaryImage: '/images/categories/Wearables/Wearables_SUMMARY.png',
    subcategories: [
      {
        id: 'dtf-heat-transfers',
        name: 'DTF Heat Transfers',
        folder: 'DTF_Heat_Transfers'
      },
      {
        id: 'dtf-by-sheet',
        name: 'DTF Heat Transfers (By Sheet)',
        folder: 'DTF_Heat_Transfers_By_Sheet'
      },
      {
        id: 'emblems-patches',
        name: 'Emblems (Patches)',
        folder: 'Emblems_Patches'
      },
      {
        id: 'name-badges',
        name: 'Name Badges',
        folder: 'Name_Badges'
      },
      {
        id: 'classic-tattoos',
        name: 'Classic Tattoos',
        folder: 'Classic_Tattoos'
      },
      {
        id: 'tattoo-booklets',
        name: 'Tattoo Booklets',
        folder: 'Tattoo_Booklets'
      }
    ]
  }
};

export const getSubcategoryImages = (categoryFolder, subcategoryFolder) => {
  const base = `/images/categories/${categoryFolder}/${subcategoryFolder}`;
  return {
    main: `${base}.png`,
    summary: `${base}_SUMMARY.png`,
    text: `${base}_TEXT.png`,
    features: `${base}_FEATURES.png`
  };
};
